import React from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import styles from './RoundedButton.module.scss';

const RoundedButton = ({ className, ...props }) => {
  return <Button {...props} className={cn(styles.root, className)} />;
};

export default RoundedButton;
